export default function NewCommentIcon() {
    return (
        <svg
            width='22'
            height='23'
            viewBox='0 0 22 23'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5.21644 19.2846L2.44444 22.0566V16.9759C0.916667 15.1914 0 12.9193 0 10.4455C0 4.70842 4.92556 0.0566406 11 0.0566406C17.0744 0.0566406 22 4.70842 22 10.4455C22 16.1826 17.0744 20.8344 11 20.8344C8.96869 20.8409 6.97234 20.306 5.21644 19.2846Z'
                fill='white'
            />
        </svg>
    );
}
